import { render, staticRenderFns } from "./CancelInternalIssue.vue?vue&type=template&id=558328d6"
import script from "./CancelInternalIssue.vue?vue&type=script&lang=js"
export * from "./CancelInternalIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports